<div
  class="modal-header container-fluid ab-modal__header"
  [ngClass]="{ 'bkg-color--grey-1000': toTier === 2 }"
  tabindex="0"
>
  <div class="ab-modal__close">
    <button
      class="btn btn--link-color btn--no-shadow"
      type="button"
      (click)="activeModal.close()"
    >
      <i class="glyphicon glyphicon--45-deg glyphicon-ab-plus"></i>
      &nbsp;<span class="ab-modal__close__text">Close</span>
    </button>
  </div>
</div>
<div class="modal-body container-fluid ab-modal__body">
  <div class="row mb-3 text-center" *ngIf="toTier === 2">
    <div class="col-md-12">
      <h4 class="ab-modal__subtitle">
        Get immediate access to these <strong>core features</strong>
      </h4>
    </div>
    <div class="col-md-4">
      <img
        class="feature-thumb"
        src="{{ appEnv.cdnUrl }}/{{
          appEnv.assetsPath
        }}/images/upgrade-thumb-01-totier-2.png"
        srcset="
          {{appEnv.cdnUrl}}/{{appEnv.assetsPath}}/images/upgrade-thumb-01-totier-2.png    1x,
          {{appEnv.cdnUrl}}/{{appEnv.assetsPath}}/images/upgrade-thumb-01-totier-2@2x.png 2x
        "
      />Pinpoint the most critical errors with Advanced Search
    </div>
    <div class="col-md-4">
      <img
        class="feature-thumb"
        src="{{ appEnv.cdnUrl }}/{{
          appEnv.assetsPath
        }}/images/upgrade-thumb-02-totier-2.png"
        srcset="
          {{appEnv.cdnUrl}}/{{appEnv.assetsPath}}/images/upgrade-thumb-02-totier-2.png    1x,
          {{appEnv.cdnUrl}}/{{appEnv.assetsPath}}/images/upgrade-thumb-02-totier-2@2x.png 2x
        "
      />Integrate Airbrake directly into your workflow
    </div>
    <div class="col-md-4">
      <img
        class="feature-thumb"
        src="{{ appEnv.cdnUrl }}/{{
          appEnv.assetsPath
        }}/images/upgrade-thumb-03-totier-2.png"
        srcset="
          {{appEnv.cdnUrl}}/{{appEnv.assetsPath}}/images/upgrade-thumb-03-totier-2.png    1x,
          {{appEnv.cdnUrl}}/{{appEnv.assetsPath}}/images/upgrade-thumb-03-totier-2@2x.png 2x
        "
      />See an overview of all your projects with detailed analytics
    </div>
  </div>
  <div class="row mb-3 text-center" *ngIf="toTier === 2">
    <div class="col-md-4">
      <img
        class="feature-thumb"
        src="{{ appEnv.cdnUrl }}/{{
          appEnv.assetsPath
        }}/images/upgrade-thumb-04-totier-2.png"
        srcset="
          {{appEnv.cdnUrl}}/{{appEnv.assetsPath}}/images/upgrade-thumb-04-totier-2.png    1x,
          {{appEnv.cdnUrl}}/{{appEnv.assetsPath}}/images/upgrade-thumb-04-totier-2@2x.png 2x
        "
      />Hotspots
    </div>
    <div class="col-md-4">
      <img
        class="feature-thumb"
        src="{{ appEnv.cdnUrl }}/{{
          appEnv.assetsPath
        }}/images/upgrade-thumb-05-totier-2.png"
        srcset="
          {{appEnv.cdnUrl}}/{{appEnv.assetsPath}}/images/upgrade-thumb-05-totier-2.png    1x,
          {{appEnv.cdnUrl}}/{{appEnv.assetsPath}}/images/upgrade-thumb-05-totier-2@2x.png 2x
        "
      />Code Insights
    </div>
    <div class="col-md-4">
      <img
        class="feature-thumb"
        src="{{ appEnv.cdnUrl }}/{{
          appEnv.assetsPath
        }}/images/upgrade-thumb-06-totier-2.png"
        srcset="
          {{appEnv.cdnUrl}}/{{appEnv.assetsPath}}/images/upgrade-thumb-06-totier-2.png    1x,
          {{appEnv.cdnUrl}}/{{appEnv.assetsPath}}/images/upgrade-thumb-06-totier-2@2x.png 2x
        "
      />Breadcrumbs &amp; Code hunks
    </div>
  </div>
  <div class="row mb-3 text-center" *ngIf="toTier === 3">
    <div class="col-md-12">
      <h4 class="ab-modal__subtitle">
        Get immediate access to these <strong>advanced features</strong>
      </h4>
    </div>
    <div class="col-md-4">
      <img
        class="feature-thumb"
        src="{{ appEnv.cdnUrl }}/{{
          appEnv.assetsPath
        }}/images/upgrade-thumb-01-totier-3.png"
        srcset="
          {{appEnv.cdnUrl}}/{{appEnv.assetsPath}}/images/upgrade-thumb-01-totier-3.png    1x,
          {{appEnv.cdnUrl}}/{{appEnv.assetsPath}}/images/upgrade-thumb-01-totier-3@2x.png 2x
        "
      />Add your own custom filters
    </div>
    <div class="col-md-4">
      <img
        class="feature-thumb"
        src="{{ appEnv.cdnUrl }}/{{
          appEnv.assetsPath
        }}/images/upgrade-thumb-02-totier-3.png"
        srcset="
          {{appEnv.cdnUrl}}/{{appEnv.assetsPath}}/images/upgrade-thumb-02-totier-3.png    1x,
          {{appEnv.cdnUrl}}/{{appEnv.assetsPath}}/images/upgrade-thumb-02-totier-3@2x.png 2x
        "
      />Pin your custom aggregations
    </div>
    <div class="col-md-4">
      <img
        class="feature-thumb"
        src="{{ appEnv.cdnUrl }}/{{
          appEnv.assetsPath
        }}/images/upgrade-thumb-03-totier-3.png"
        srcset="
          {{appEnv.cdnUrl}}/{{appEnv.assetsPath}}/images/upgrade-thumb-03-totier-3.png    1x,
          {{appEnv.cdnUrl}}/{{appEnv.assetsPath}}/images/upgrade-thumb-03-totier-3@2x.png 2x
        "
      />Receive high volume alert notifications
    </div>
  </div>
  <div
    class="ab-modal__full-edge-bg ab-modal__full-edge-bg--bottom bkg-color--grey-1000"
  >
    <div class="text-center">
      <a
        class="btn btn--success btn--default"
        href="{{ upgradeUrl }}"
        target="_self"
        >Pick a plan</a
      >
    </div>
  </div>
</div>
